import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import useProfile from '@api/hooks/profile/useProfile';
import { breakpoints } from '@styles/index';
import EducatorHeader from './EducatorHeader';
import EducatorProfileFeed from './EducatorProfileFeed';
import EducatorHighlights from './EducatorHighlights';

const Wrapper = styled.div`
  grid-column: span 24;
  display: grid;
  grid-template-columns: repeat(24, 32px);
  grid-column-gap: 16px;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    grid-column: span 10;
    display: flex;
    flex-flow: column-reverse;
    grid-column-gap: 0;
  }
`;

const EducatorProfile = ({ username, children }) => {
  const { profileData: educator } = useProfile(username);
  const isPlatinumEducator = !!(
    educator?.isPlatformEducator || educator?.isPlatinumEducator
  );
  return (
    <>
      <EducatorHeader
        username={username}
        isPlatinumEducator={isPlatinumEducator}
      />
      <Wrapper>
        <EducatorProfileFeed
          username={username}
          isPlatinumEducator={isPlatinumEducator}
        />
        <EducatorHighlights
          username={username}
          isPlatinumEducator={isPlatinumEducator}
        />
        {children}
      </Wrapper>
    </>
  );
};

export default EducatorProfile;

EducatorProfile.propTypes = {
  username: PropTypes.string
};

EducatorProfile.defaultProps = {
  username: ''
};
